// Shared extracted-invoice (invoice-extractor) payload logic used by both the
// Mission Control ReviewSidebar and the dashboard Finance Approvals page.
// Presentation is per-surface; this module is logic only.

// An extracted-invoice approval payload nests the proposed finance_invoices
// record under `__finance_invoice` using camelCase keys — a different shape
// from the outbound invoice *generator*'s top-level snake_case payload, so
// consumers detect it on its own.

// NO edit-payload builder lives here (unlike draftReply's
// buildDraftReplyEditedPayload). Invoice gates are terminal and
// enrichment-committed: the decide handler treats a non-empty editedPayload as
// a WHOLESALE replacement of the approval payload, so an edit would have to
// clone the full payload (including __finance_invoice and __reconciliation —
// where a careless edit could flip needs_review to ok_to_pay and queue a real
// Xero draft) rather than diff it. v1 is review + approve/reject only.

export interface ExtractedLineItem {
  description: string
  quantity:    number
  amount:      number   // line total (extractor emits no unit price / tax)
}

export interface ExtractedInvoice {
  invoiceNumber: string
  vendorName:    string
  vendorEmail?:  string
  currency:      string
  amount:        number
  dueDate?:      string
  aiSummary?:    string
  lineItems:     ExtractedLineItem[]
}

/** Reads an invoice-extractor result nested under `__finance_invoice`. */
export function asExtractedInvoicePayload(v: unknown): ExtractedInvoice | null {
  if (!v || typeof v !== 'object') return null
  const fi = (v as Record<string, unknown>).__finance_invoice
  if (!fi || typeof fi !== 'object') return null
  const o = fi as Record<string, unknown>
  if (
    typeof o.invoiceNumber !== 'string' ||
    !Array.isArray(o.lineItems) ||
    o.lineItems.length === 0
  ) return null
  return o as unknown as ExtractedInvoice
}
